var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumbers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.039,
    height: 13,
    viewBox: "0 0 21.039 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "numbers",
    transform: "translate(0 -96.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38263",
    "data-name": "Path 38263",
    d: "M20.372,96.5H.666A.666.666,0,0,0,0,97.166v11.667a.666.666,0,0,0,.666.666H20.372a.666.666,0,0,0,.666-.666V97.166A.666.666,0,0,0,20.372,96.5Zm-.666,11.667H1.333V97.833H19.706Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38264",
    "data-name": "Path 38264",
    d: "M68.407,184.971v3.485a.666.666,0,0,0,1.333,0v-4.43a.667.667,0,0,0-1.039-.552l-.461.311A.667.667,0,0,0,68.407,184.971Z",
    transform: "translate(-65.116 -83.241)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38265",
    "data-name": "Path 38265",
    d: "M181.624,184.413l1-.462a.654.654,0,0,1,.754.338.646.646,0,0,1-.335.882c-.059.024.058-.04-1.6.912a1.232,1.232,0,0,0,.6,2.3c2.678.028,1.942.022,2.073.022a.666.666,0,0,0,.007-1.333l-1.694-.018,1.169-.669a1.977,1.977,0,0,0-1.489-3.662l-1.037.48a.666.666,0,1,0,.56,1.209Z",
    transform: "translate(-173.152 -82.5)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38266",
    "data-name": "Path 38266",
    d: "M336.206,182.7h1.529l-.554.563a.667.667,0,0,0,.475,1.134.784.784,0,1,1-.7,1.128.666.666,0,1,0-1.2.586,2.117,2.117,0,1,0,3.116-2.664l.363-.369a1.006,1.006,0,0,0-.716-1.711h-2.312a.666.666,0,1,0,0,1.333Z",
    transform: "translate(-321.564 -81.336)",
    fill: "#898989"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumbers);
export default __webpack_public_path__ + "static/media/numbers.3f0632d0.svg";
export { ForwardRef as ReactComponent };